module.exports = __webpack_public_path__ + "static/media/about-header-image3.cee37c4e.png";